import { Icon } from "@silversea-ssc/ui-components-react";
import clsx from "clsx";
import React, { useRef, useState } from "react";
import { INavLinks } from "../../../HeaderNavBar/type";
import * as styles from "./FooterNav.module.scss";
import FooterNavLink from "./FooterNavLink";

interface FooterNavProps {
  id: string;
  label: string;
  links?: INavLinks;
}

const FooterNav: React.FC<React.PropsWithChildren<FooterNavProps>> = ({
  id,
  label,
  links
}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div
      ref={containerRef}
      id={`${id}-button`}
      className={clsx(styles.footerNav, { [styles.open]: isOpen })}
      aria-owns={id}
    >
      <button
        className={styles.button}
        id={id}
        onClick={() => setIsOpen(!isOpen)}
        aria-label={label?.toString()}
        aria-expanded={isOpen}
      >
        <span>{label}</span>
        <Icon
          name="chevron-down"
          size="1.5x"
          padding={false}
          className={styles.icon}
          ariaHidden={true}
        />
      </button>
      <div tabIndex={-1} className={clsx(styles.contentWrapper)}>
        {links && (
          <div tabIndex={-1}>
            <ul role="menu" aria-labelledby={`${id}-button`}>
              {links.map((l) => (
                <li key={l.href} role="presentation">
                  <FooterNavLink link={l} role="menuitem" />
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
};

export default FooterNav;
